export { default } from './deprecatedPropType';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/deprecatedPropType/index.js
// module id = 744
// module chunks = 22